import * as v from 'valibot';

/* Spot Bid Expiration Options */
export const timerangeOptionApiSchema = v.object({
  disabled: v.boolean(),
  group: v.nullable(v.string()),
  selected: v.boolean(),
  text: v.string(),
  value: v.string(),
});

export const spotBidExpireTimeApiSchema = v.object({
  day: v.number(),
  listTimerange: v.array(timerangeOptionApiSchema),
  maxBidHours: v.string(),
  time: v.number(),
});

export type TimerangeOption = v.InferOutput<typeof timerangeOptionApiSchema>;
export type SpotBidExpireTimeOptionsApi = v.InferOutput<typeof spotBidExpireTimeApiSchema>;
